// extracted by mini-css-extract-plugin
export default {"userSubscriptionDetail":"styles_userSubscriptionDetail__rEiDl","addButton":"styles_addButton__WxTJn"};